const playersArr = ["south", "west", "north", "east"];

export default playersArr;
